export default "__VITE_ASSET__BkppuEmv__"